import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { brand, heroBadges, heroImage } from '../data/content';
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="w-full bg-white pb-16 pt-12 md:pb-24 md:pt-16" data-id="element-93" data-mp="4lqfmm6wsuyr">
      <div className="mx-auto w-full max-w-content px-5 text-center md:px-8" data-id="element-94" data-mp="4jm5hmif2zq1">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease
      }} className="mx-auto max-w-4xl font-display text-[2.5rem] font-extrabold leading-[1.04] tracking-tight text-ink sm:text-5xl md:text-6xl" data-id="element-95" data-mp="128yye9fizpx2">
          {brand.promise}
          <br data-id="element-96" data-mp="neklmqmk1cqu" />
          <span className="text-blue-600" data-id="element-97" data-mp="3d1a8hk3o4bda">{brand.promiseAccent}</span>
        </motion.h1>

        <motion.img initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease
      }} src={heroImage} alt={brand.mockupCaption} className="mx-auto mt-10 w-full max-w-2xl" width={1240} height={1240} data-id="element-98" data-mp="382fedm0930dv" />

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.18,
        ease
      }} className="mx-auto mt-10 max-w-3xl" data-id="element-99" data-mp="399jmzcfv4d5l">
          <p className="text-xl leading-relaxed text-blue-900/80 md:text-2xl" data-id="element-100" data-mp="30gq4l654cxni">{brand.subtitle}</p>

          <ul className="mt-7 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm font-semibold text-blue-900/70" data-id="element-101" data-mp="35a2gqgsm3bzd">
            {heroBadges.map(badge => <li key={badge} className="inline-flex items-center gap-1.5" data-id="element-102" data-mp="2vjzpal152635">
                <CheckIcon className="h-4 w-4 text-mint-500" aria-hidden="true" data-id="element-103" data-mp="2hinbaf5jgejw" />
                {badge}
              </li>)}
          </ul>

          <div className="mt-9" data-id="element-104" data-mp="2ljz5yz39rpyy">
            <CtaButton size="xl" className="w-full max-w-2xl" data-id="element-105" data-mp="s1rr4kwyw0sp">
              Quiero los 50 Mapas ahora
            </CtaButton>
          </div>

          <p className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-blue-900/70" data-id="element-106" data-mp="naji3pzjuhg2">
            <ShieldCheckIcon className="h-4 w-4 text-mint-500" aria-hidden="true" data-id="element-107" data-mp="iczzyezqdkiu" />
            Garantía de 7 días o te devolvemos tu dinero
          </p>
        </motion.div>
      </div>
    </section>;
}